import { useFormikContext } from "formik";
import { useEffect, ReactNode } from "react";

import { getParamByName, getSessionStorageKey } from "../../Helpers/WindowHelpers";

interface CaptureExternalBrandInterface {

}

const CaptureExternalBrand = ({}: CaptureExternalBrandInterface):ReactNode => {
    const context = useFormikContext<any>();
    const initialize = () => {
        if(sessionStorage.getItem(getSessionStorageKey())) return;
        const selectedBrand = (document.querySelector('#tub-brand') as HTMLSelectElement | null)?.value;
        const queryValue = selectedBrand || getParamByName('brand');
        if(!queryValue || context.values.brand == queryValue) return;
        context.setFieldValue('brand', queryValue);
    }

    const onChange = (e: Event) => {
        context.setFieldValue('brand', (e.currentTarget as HTMLSelectElement).value) 
    }

    useEffect(() => {
        initialize();
        let currentEl: Element | null = null;
        const handleChange = (e: Event) => {
            onChange(e);
        };

        const attach = () => {
            const el = document.querySelector('#tub-brand');
            if (!el || el === currentEl) return;

            if (currentEl) {
                currentEl.removeEventListener("change", handleChange as EventListener);
            }

            currentEl = el;
            el.addEventListener("change", handleChange as EventListener);
        };

        attach();
        initialize();

        const obs = new MutationObserver(() => {
            attach();
            initialize();
        });
        obs.observe(document.documentElement, {
            childList: true,
            subtree: true,
        });

        return () => {
            obs.disconnect();
            if (currentEl) {
                currentEl.removeEventListener("change", handleChange as EventListener);
            }
        };
    }, []);

    return null;
}

export default CaptureExternalBrand;
